import { useCart } from "./CartContext";

export default function CartWidget() {
  const { cart, setDrawerOpen } = useCart();
  const count = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <button onClick={() => setDrawerOpen(true)}>
      🛒 <span className="cart-widget-label">View Cart</span> ({count})
    </button>
  );
}
